import { useState, useCallback } from "react";

export function useLightbox(totalImages: number) {
  const [isOpen, setIsOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);

  const open = useCallback((index: number) => {
    setCurrentIndex(index);
    setIsOpen(true);
  }, []);

  const close = useCallback(() => {
    setIsOpen(false);
  }, []);

  const prev = useCallback(() => {
    setCurrentIndex((i) => (i > 0 ? i - 1 : totalImages - 1));
  }, [totalImages]);

  const next = useCallback(() => {
    setCurrentIndex((i) => (i < totalImages - 1 ? i + 1 : 0));
  }, [totalImages]);

  return { isOpen, currentIndex, open, close, prev, next };
}
